function initSpinWheelPopup() {
  const popup = document.querySelector('[data-spin-wheel-popup]');
  if (!popup) return;

  const playedKey = 'aton-spin-wheel-played';
  const dismissedKey = 'aton-spin-wheel-dismissed';
  const delay = parseInt(popup.dataset.delay, 10) || 8000;
  const alreadyHandled = popup.dataset.formPosted === 'true';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const configEl = popup.querySelector('[data-spin-wheel-config]');
  const segments = configEl ? JSON.parse(configEl.textContent) : [];

  const emailStep = popup.querySelector('[data-spin-step="email"]');
  const wheelStep = popup.querySelector('[data-spin-step="wheel"]');
  const resultStep = popup.querySelector('[data-spin-step="result"]');
  const dial = popup.querySelector('[data-spin-dial]');
  const spinBtn = popup.querySelector('[data-spin-button]');
  const resultWin = popup.querySelector('[data-spin-result-win]');
  const resultLose = popup.querySelector('[data-spin-result-lose]');

  function open() {
    popup.hidden = false;
  }

  function close() {
    popup.hidden = true;
    try {
      if (!window.localStorage.getItem(playedKey)) {
        window.localStorage.setItem(dismissedKey, Date.now().toString());
      }
    } catch (error) {
      /* localStorage unavailable, ignore */
    }
  }

  function showStep(step) {
    [emailStep, wheelStep, resultStep].forEach((el) => {
      if (el) el.hidden = el !== step;
    });
  }

  function markPlayed(result) {
    try {
      window.localStorage.setItem(
        playedKey,
        JSON.stringify({ ...result, timestamp: Date.now() })
      );
    } catch (error) {
      /* localStorage unavailable, ignore */
    }
  }

  function getPlayed() {
    try {
      const raw = window.localStorage.getItem(playedKey);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function renderResult(segment) {
    if (!segment || segment.isLosing || !segment.code) {
      resultWin.hidden = true;
      resultLose.hidden = false;
      return;
    }

    resultLose.hidden = true;
    resultWin.hidden = false;
    resultWin.querySelector('[data-spin-result-label]').textContent = segment.label;
    resultWin.querySelector('[data-spin-result-code]').textContent = segment.code;

    const cta = resultWin.querySelector('[data-spin-result-cta]');
    if (cta) {
      cta.href = `${window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/'}discount/${encodeURIComponent(segment.code)}?redirect=/collections/all`;
    }

    const copyBtn = resultWin.querySelector('[data-spin-copy]');
    if (copyBtn) {
      copyBtn.addEventListener(
        'click',
        () => {
          navigator.clipboard?.writeText(segment.code).then(() => {
            const original = copyBtn.textContent;
            copyBtn.textContent = 'Copied!';
            window.setTimeout(() => {
              copyBtn.textContent = original;
            }, 1800);
          });
        },
        { once: true }
      );
    }
  }

  function spin() {
    if (!dial || segments.length === 0) return;
    spinBtn.disabled = true;

    const winningIndex = Math.floor(Math.random() * segments.length);
    const anglePer = 360 / segments.length;
    const winningCenter = winningIndex * anglePer + anglePer / 2;
    const baseRotation = (360 - winningCenter) % 360;
    const extraSpins = reduceMotion ? 1 : 6;
    const totalRotation = extraSpins * 360 + baseRotation;
    const duration = reduceMotion ? 0.6 : 4.5;

    dial.style.transition = `transform ${duration}s cubic-bezier(0.15, 0.85, 0.25, 1)`;
    // Force reflow so the transition reliably applies before the transform change.
    void dial.offsetWidth;
    dial.style.transform = `rotate(${totalRotation}deg)`;

    dial.addEventListener(
      'transitionend',
      () => {
        const segment = segments[winningIndex];
        markPlayed(segment);
        renderResult(segment);
        showStep(resultStep);
      },
      { once: true }
    );
  }

  popup.querySelectorAll('[data-spin-wheel-close]').forEach((btn) => {
    btn.addEventListener('click', close);
  });

  popup.addEventListener('click', (event) => {
    if (event.target === popup) close();
  });

  document.addEventListener('keydown', (event) => {
    if (!popup.hidden && event.key === 'Escape') close();
  });

  if (spinBtn) {
    spinBtn.addEventListener('click', spin, { once: true });
  }

  const played = getPlayed();

  if (played) {
    // Already played on a previous visit: never show the popup again.
    return;
  }

  if (alreadyHandled) {
    showStep(wheelStep);
    open();
    return;
  }

  let dismissedAt = null;
  try {
    dismissedAt = window.localStorage.getItem(dismissedKey);
  } catch (error) {
    dismissedAt = null;
  }

  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  if (dismissedAt && Date.now() - parseInt(dismissedAt, 10) < sevenDays) {
    return;
  }

  showStep(emailStep);
  window.setTimeout(open, delay);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSpinWheelPopup);
} else {
  initSpinWheelPopup();
}
